import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import SubscribersOnlyOwnersTooltip from './SubscribersOnlyOwnersTooltip';
import SubscribersOnlyTooltip from './SubscribersOnlyTooltip';
import s from './SubscribersOnly.scss';
const SubscribersOnly = ({ deviation , className , textClassName  })=>{
    const { t  } = useTranslation();
    const { tier , isOwner  } = useSubscriptionTier(deviation);
    if (!tier || !tier.author) {
        return null;
    }
    const Tooltip = isOwner ? SubscribersOnlyOwnersTooltip : SubscribersOnlyTooltip;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Tooltip, {
        deviation: deviation,
        linkClassName: s['subs-link']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['contents']
    }, /*#__PURE__*/ React.createElement(PromoBadge, {
        badgeType: "tier",
        size: 40
    }), /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['text'], textClassName)
    }, t('deviation.tier.subscribersOnly')))));
};
SubscribersOnly.displayName = 'SubscribersOnly';
export default SubscribersOnly;
